import { Apollo, gql } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { AttemptLogin, GetCurrentUser, LogOut } from '../../common/generated-types';
import { ATTEMPT_LOGIN, GET_CURRENT_USER, LOG_OUT } from '../definitions/auth-definitions';

import { BaseDataService } from './base-data.service';

export class AuthDataService {
  constructor(private baseDataService: BaseDataService, private apollo: Apollo) {}

  currentUser() {
    return this.baseDataService.query<GetCurrentUser.Query>(GET_CURRENT_USER);
  }

  attemptLogin(username: string, password: string, rememberMe: boolean) {
    // return this.baseDataService.mutate<AttemptLogin.Mutation, AttemptLogin.Variables>(ATTEMPT_LOGIN, {
    //     username,
    //     password,
    //     rememberMe,
    // });
    return this.apollo
      .mutate({
        mutation: gql`
          mutation attemptLogin($input: AuthenticationInput, $rememberMe: Boolean) {
            adminLogin(input: $input, rememberMe: $rememberMe) {
              __typename
              ... on CurrentUser {
                id
                identifier
                channels {
                  id
                  token
                  permissions
                  code
                }
              }
              ... on InvalidCredentialsError {
                errorCode
                message
                authenticationError
              }
            }
          }
        `,
        variables: { input: { native: { username, password } }, rememberMe },
      })
      .pipe(map((res: any) => ({ login: res.data.adminLogin })));
  }

  logOut() {
    return this.baseDataService.mutate<LogOut.Mutation>(LOG_OUT);
  }
}
